import { navy } from '@zocdoc/branding/colors';
import { breakpoint } from '@zocdoc/components/src/grid';
import { sharpSansBold } from '@zocdoc/components/src/typography';
import styled from 'styled-components';

const Headline = styled.h2`
    color: ${navy};

    ${breakpoint.xxsmall} {
        ${sharpSansBold(24, 32)}
        padding-bottom: 12px;
    }
    ${breakpoint.small} {
        ${sharpSansBold(40, 48)}
        padding-bottom: 24px;
    }
    ${breakpoint.medium} {
        ${sharpSansBold(56, 64)}
        padding-bottom: 40px;
    }
`;

export default Headline;
